import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import ImportarScreen from './screen';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';
import { PeriodosAdapter } from '../../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { ImportacionesLogAdapter } from '../../../../../../infraestructure/persistence/rest/ImportacionesLogAdapter';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';

export const ImportarContainer = () => {

	const api = new InformesDetalleAdapter();
	const apiPeriodos = new PeriodosAdapter();
	const apiLog = new ImportacionesLogAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let result: any;
	let [año, setAño] = useState<any>(undefined);
	let [reunion, setReunion] = useState<any>(undefined);
	let [ dataLog, setDataLog ] = useState<any>([]);

	useEffect(()=>{
	getTiposContenido();
	},[])

	const getTiposContenido = async () => {
		try {
			result = await apiPeriodos.getTiposContenidoPeriodoAbierto();
			if(result.data && result.data!=="")
			{
				var data = ([ ...result.data ] || []);
					if(data.length > 0){
						setAño(([ ...result.data ] || [])[0].año);
						setReunion(([ ...result.data ] || [])[0].reunion);
					}else{
						setAño(undefined);
						setReunion(undefined);
					}
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const adjuntarFicheros = async (data: any) => {
		try {
			setDataLog([]);
			result = await api.ImportarFichero(data);
			getLogImportaciones();
			if(result.data && result.data!==""){
				launchNotification({type:"success",title:"Importar",message:"Se ha importado el archivo."})
				return result.data;
			}else{resultError(); return false}
		} catch (e) {
			getLogImportaciones();
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
  	};

	const getLogImportaciones = async() => {
		try {
			result = await apiLog.ListarUltimaImportacion();
			if(result.data && result.data!==""){
				//launchNotification({type:"success",title:"Importar",message:"Se ha recibido el Log."})
				setDataLog(result.data);
				console.log('getLogImportaciones', result.data);
				return result.data;
			}else{resultError(); return false}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	}

	const filtrarDetalleImportacion = async (data: any) => {
		try {
			result = await apiLog.ListarDetalle(data);
			if(result.data && result.data!=="")
			{
				return result.data;
			}else{resultError(); return [];}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
			return [];
		}
  	};

	return (
		<>
			<ImportarScreen handleImportar={adjuntarFicheros} año={año} reunion={reunion} dataLog={dataLog} onDetalleFilter={filtrarDetalleImportacion}/>
		</>
	);
};

export default ImportarContainer;
